import { atom } from "recoil";

export const ori_headers = [
  "parent_id",
  "student_id",
  "student_name",
  "student_age",
  "student_gender",
  "student_school",
  "student_tel",
  "parent_tel",
  "email",
  "memo",
  // "lecture_title",
];
const headers = [
  "부모_id",
  "학생_id",
  "이름",
  "나이",
  "성별",
  "학교",
  "전화번호",
  "학부모 전화번호",
  "이메일",
  // "수업",
  "메모",
];
const widths = [
  "w-16",
  "w-16",
  "w-16",
  "w-12",
  "w-12",
  "w-32",
  "w-32",
  "w-32",
  "w-44",
  "w-60",
];

export const userList = atom({
  key: "user/list",
  default: { headers, contents: [], widths },
});
